import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'
import { useJobTitlesQuery } from '../../../queries/job-titles'
import useStore from '../../../store'
import { buildListAsInputOptions } from '../../../utils/forms'
import { Element } from 'react-bulma-components'

interface JobTitleFilterFieldProps {
  disabledQueries?: boolean
  queriesStaleTime?: number
  employerIds?: string[]
  tooltip?: string
}

const JobTitleFilterField: React.FC<JobTitleFilterFieldProps> = ({
  disabledQueries,
  queriesStaleTime,
  employerIds,
  tooltip,
}) => {
  const currentUserRole = useStore(state => state.session.currentUserRole)
  const jobTitlesQuery = useJobTitlesQuery(
    currentUserRole === 'interimAgencyMember'
      ? {
          employer: employerIds,
        }
      : {},
    {
      enabled: !disabledQueries && (currentUserRole === 'employerMember' || Boolean(employerIds)),
      staleTime: queriesStaleTime || 1000 * 60 * 2,
    },
  )
  return (
    <FieldColumn>
      <Element data-tooltip={tooltip}>
        <Field
          label="Métier"
          name="jobTitle"
          component={MultiSelectField}
          disabled={!jobTitlesQuery.data || !jobTitlesQuery.data[0]}
          options={buildListAsInputOptions(jobTitlesQuery.data || [])}
        />
      </Element>
    </FieldColumn>
  )
}

export default JobTitleFilterField
